import Vue from "vue";
import VueRouter from "vue-router";

// Client Side
import Home from "./pages/Home.vue";
import About from "./pages/About.vue";
import Vault from "./pages/Vault";
import VaultDetail from "./pages/VaultDetail";
import Academy from "./pages/Academy/Main";
import Disclaimer from "./pages/Disclaimer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsCondition from "./pages/TermsCondition";
import LandingPage from "./pages/LandingPage";
import RestrictedPage from "./pages/RestrictedPage";

// Admin Side
import Login from "./pages/admin/Login.vue";
import Dashboard from "./pages/admin/Dashboard.vue";
import AdminVault from "./pages/admin/Vault/Vault.vue";
import AdminVaultDetail from "./pages/admin/Vault/VaultsDetails.vue";
import AdminVaultCreate from "./pages/admin/Vault/VaultCreate.vue";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    // mode: "hash",
    // base: process.env.BASE_URL,
    linkExactActiveClass: "active",
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: [
        // {
        //     path: "/",
        //     name: "home",
        //     // name: "landing.page",
        //     component: LandingPage,
        //     meta: { layout: "empty" }
        // },
        {
            path: '/',
            name: 'home',
            beforeEnter(to, from, next) {
                // Check if the path is exactly '/'
                if (to.path === '/') {
                    window.location.href = 'https://www.thetanuts.finance';
                } else {
                    // For other paths, continue as normal
                    next();
                }
            }
        },
        //{
        //    path: "/",
        //    name: "home",
        //    // name: "landing.page",
        //    redirect: "/www"
        //},        
        // {
        //     path: "/restricted",
        //     name: "restricted",
        //     name: "restricted",
        //     component: RestrictedPage,
        //     meta: { layout: "empty" }
        // },
        // {
        //     path: "/app",
        //     name: "app",
        //     component: Home
        // },
        // {
        //     path: "/about",
        //     name: "about",
        //     component: About
        // },
        {
            path: "/basic/vaults",
            name: "vault",
            component: Vault
        },
        {
            path: "/basic/vaults/:chainId/:id",
            name: "vault_detail",
            component: VaultDetail
            //props: true
        },
        // {
        //     path: "/academy",
        //     name: "academy",
        //     component: Academy
        // },
        // {
        //     path: "/basic/disclaimer",
        //     name: "disclaimer",
        //     component: Disclaimer
        // },
        // {
        //     path: "/basic/privacypolicy",
        //     name: "privacypolicy",
        //     component: PrivacyPolicy
        // },
        // {
        //     path: "/basic/termscondition",
        //     name: "termscondition",
        //     component: TermsCondition
        // },
        {
            path: "/admin/dashboard",
            name: "dashboard",
            component: Dashboard,
            meta: {
                requiresAuth: true,
                layout: "admin",
                breadcrumb: [{ name: "Dashboard", active: true }]
            }
        },
        {
            path: "/admin/vault",
            name: "admin.vault",
            component: AdminVault,
            meta: {
                requiresAuth: true,
                layout: "admin",
                breadcrumb: [{ name: "Vaults", active: true }]
            }
        },
        {
            path: "/admin/vault/create",
            name: "admin.vault.create",
            component: AdminVaultCreate,
            meta: {
                requiresAuth: true,
                layout: "admin",
                breadcrumb: [
                    { name: "Vaults", link: "/admin/vault" },
                    { name: "Create", active: true }
                ]
            }
        },
        {
            path: "/admin/vaultdetail/:id",
            name: "admin.vaultdetail",
            component: AdminVaultDetail,
            meta: {
                requiresAuth: true,
                layout: "admin",
                breadcrumb: [
                    { name: "Vaults", link: "/admin/vault" },
                    { name: ":id" },
                    { name: "#", active: true }
                ]
            }
        },
        {
            path: "/admin/login",
            name: "login",
            component: Login,
            meta: { layout: "empty" }
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (localStorage.getItem("token") == null) {
            next({
                path: "/admin/login",
                params: { nextUrl: to.fullPath }
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
